<script>
  import { datasets } from 'modules/stores.js'

  $: ok = $datasets._status === 'ok'
  $: errored = $datasets._status === 'error'
  $: warn = $datasets._status === 'pending' || $datasets._status === 'init'

  import { apiUrl } from 'modules/stores.js'
  import { preferences } from 'modules/preferences.js'

  let url = $apiUrl
  const submit = () => {
    $apiUrl = url
  }
</script>

<style type="text/scss">

</style>

<section class="px-3 py-2" />
<form
  class="data-api form-group"
  class:errored
  class:warn
  on:submit|preventDefault={submit}>
  <label for="api-url">
    <h4 class="mb2">
      API URL
      {#if ok}
        <span class="Label bg-green-5">{$datasets.length} datasets</span>
      {/if}
    </h4>
  </label>
  <div class="note" id="api-url-note">
    Base URL to fetch origin/destination data. More info in
    <a href="https://github.com/LyonDataViz/oddata-public">oddata-public</a>
  </div>
  <input
    class="form-control"
    type="url"
    bind:value={url}
    placeholder="https://my.api.tld/"
    autocomplete="url"
    list="defaultURLs"
    id="api-url"
    aria-describedby="api-url-note" />
  {#if errored}
    <div class="error">No datasets could be fetched from this URL.</div>
  {/if}
  {#if warn}
    <div class="warn">Loading data...</div>
  {/if}
  <datalist id="defaultURLs">
    <option value={preferences.apiUrl} label="oddata-public (default)" />
  </datalist>
</form>
